export default __webpack_public_path__ + "static/media/dustbin.e56ee0e7.svg";